import { lazy } from "react";

// project imports
import AuthGuard from "utils/route-guard/AuthGuard";
import MainLayout from "layout/Layout";
import Loadable from "ui-component/Loadable";

// sample page routing
const UnitsPage = Loadable(lazy(() => import("views/pages/units")));
const BuildingsPage = Loadable(lazy(() => import("views/pages/buildings")));
const EquipPage = Loadable(lazy(() => import("views/pages/grade/equip")));
const ReplacePage = Loadable(lazy(() => import("views/pages/replace/replace")));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/",
      element: <EquipPage />
    },
    {
      path: "/units",
      element: <UnitsPage />
    },
    {
      path: "/buildings",
      element: <BuildingsPage />
    },
    {
      path: "/equip",
      element: <EquipPage />
    },
    {
      path: "/replace/:gradeType",
      element: <ReplacePage />
    }
  ]
};

export default MainRoutes;
